import { FC } from "react";
import LandingStaticSliderCourseSwiper from "@features/landing/components/common/CardsSlider/CourseSwiper";
import CardsSliderLayout from "@features/landing/components/common/CardsSlider/SliderLayout";
import SkeletonCourseList from "@features/home/components/HomeCourseSlider/SkeletonCourseList";
import { useStaticSlider } from "../../hooks/useStaticSlider";
import { TabItems } from "types/card-tab";

const LandingStaticSliderList: FC<{ initialData: TabItems }> = ({
  initialData,
}) => {
  const { activeTabTitle, showMoreLink, activeTab, slidersData } =
    useStaticSlider(initialData);
  return (
    <CardsSliderLayout
      title={activeTabTitle}
      viewAllLink={showMoreLink}
      swiperId={slidersData.slug}
    >
      {activeTab?.products?.length ? (
        <LandingStaticSliderCourseSwiper
          {...{
            activeTab,
            slug: slidersData.slug,
          }}
        />
      ) : (
        <SkeletonCourseList hasAddToCart className="mt-4 !mb-8" />
      )}
    </CardsSliderLayout>
  );
};

export default LandingStaticSliderList;
